'use client';

import Script from 'next/script'
import { useEffect } from 'react'

declare global {
    interface Window {
        gtag: (...args: unknown[]) => void;
    }
}

const GA_TRACKING_ID = process.env.NEXT_PUBLIC_GA_ID || 'G-H6WN52M9RD'

interface GoogleAnalyticsProps {
    userId?: string;
    userType?: string;
    userRole?: string;
}

const GoogleAnalytics = ({ userId, userType, userRole }: GoogleAnalyticsProps) => {
    // Set user properties when authenticated user data is available
    useEffect(() => {
        if (!userId || typeof window === 'undefined' || !window.gtag) return;

        window.gtag('config', GA_TRACKING_ID, {
            user_id: userId,
        });

        window.gtag('set', 'user_properties', {
            user_type: userType || 'authenticated',
            user_role: userRole || 'user',
        });
    }, [userId, userType, userRole]);

    return (<>
        <Script
            async
            src={`https://www.googletagmanager.com/gtag/js?id=${GA_TRACKING_ID}`}
            strategy='afterInteractive'
        />
        <Script id='google-analytics' strategy='afterInteractive'>
            {`window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${GA_TRACKING_ID}');`}
        </Script>
    </>)
}

export default GoogleAnalytics
